module.exports = __webpack_public_path__ + "img/westside-radio.a509fd48.png";